// Syarat & Ketentuan KYC Worker — sumber tunggal untuk halaman /worker/kyc-terms.
// Disusun dari docs/SNK-KYC.md (Versi 1.0). Versi ini WAJIB sama dengan yang
// divalidasi backend (snk_version). Jangan ubah teks persetujuan tanpa naikkan versi.
export const SNK_VERSION = "1.0";
export const SNK_EFFECTIVE_DATE = "2 Oktober 2026";
export const SNK_STORAGE_PREFIX = "snk-kyc";

export const snkConsentKey = (userId) => `${SNK_STORAGE_PREFIX}-v${SNK_VERSION}:${userId || "anon"}`;

export const SNK_CONSENT_STATEMENT =
  "Saya menyatakan bahwa saya telah membaca dan memahami Syarat dan Ketentuan Verifikasi Identitas dan KYC Worker Cariinjasa.com. " +
  "Saya menyatakan bahwa KTP-el dan SKCK yang saya unggah adalah milik saya sendiri, benar, sah, tidak dipalsukan atau dimanipulasi, " +
  "dan saya berwenang menyerahkannya kepada Cariinjasa untuk keperluan verifikasi. " +
  "Saya memberikan persetujuan secara eksplisit kepada Cariinjasa untuk memproses Data Pribadi saya sebagaimana dijelaskan " +
  "dalam Ketentuan KYC dan Kebijakan Privasi Cariinjasa, sesuai dengan tujuan dan dasar pemrosesan yang berlaku " +
  "berdasarkan peraturan perundang-undangan Republik Indonesia.";

export const SNK_SUMMARY = [
  {
    title: "Tujuan",
    desc: "Verifikasi identitas & kelayakan Worker, keamanan Customer, cegah fraud dan pemalsuan identitas.",
  },
  {
    title: "Data yang diproses",
    desc: "KTP-el (nama, NIK, foto), foto selfie + KTP, dan SKCK yang masih berlaku + tanggal kedaluwarsa.",
  },
  {
    title: "Dasar pemrosesan",
    desc: "Persetujuan eksplisit Anda + pemenuhan perjanjian pendaftaran Worker (UU PDP Pasal 20).",
  },
  {
    title: "Retensi",
    desc: "Disimpan hanya selama diperlukan untuk verifikasi, keamanan, sengketa & kewajiban hukum. Dihapus setelah tujuan tercapai.",
  },
  {
    title: "Akses",
    desc: "Hanya tim verifikasi berwenang (need-to-know). Customer hanya melihat badge “Terverifikasi”, bukan dokumen mentah.",
  },
  {
    title: "Pihak ketiga",
    desc: "Infrastruktur cloud/penyimpanan yang terikat perjanjian pelindungan data. Tidak dijual atau disebarluaskan.",
  },
  {
    title: "Transfer data",
    desc: "Diproses di wilayah Indonesia. Transfer ke luar negeri hanya sesuai UU PDP bila diperlukan.",
  },
  {
    title: "Hak Anda",
    desc: "Akses, koreksi, penghapusan, pembatasan, keberatan, dan penarikan persetujuan sesuai UU PDP.",
  },
];

export const SNK_SECTIONS = [
  {
    no: "1",
    title: "Ketentuan Umum",
    body: [
      "Ketentuan KYC ini adalah bagian tak terpisahkan dari Syarat & Ketentuan Cariinjasa.com dan berlaku bagi setiap calon maupun terdaftar Mitra/Worker yang wajib verifikasi identitas.",
      "Definisi: Cariinjasa = pengelola platform; Worker = perseorangan penyedia jasa; KYC = verifikasi identitas & kelayakan administratif; Dokumen KYC = KTP-el, SKCK, dan dokumen pendukung sah lainnya.",
    ],
  },
  {
    no: "2",
    title: "Kewajiban Verifikasi",
    body: [
      "Calon Worker wajib memberi informasi & dokumen yang benar, lengkap, akurat, sah, dan masih berlaku.",
      "Verifikasi adalah syarat wajib sebelum: aktivasi akun Worker, menawarkan jasa, menerima pekerjaan, membuka fitur Worker tertentu, dan mendapat status Terverifikasi.",
      "Yang tidak menyelesaikan verifikasi dapat ditolak, ditunda, dibatasi, atau dinonaktifkan akses fitur Worker-nya.",
    ],
  },
  {
    no: "3",
    title: "Dokumen yang Wajib Diunggah",
    body: [
      "Cariinjasa meminta: (a) KTP-el, (b) SKCK, (c) dokumen pendukung lain yang wajar untuk verifikasi/keamanan/kelayakan.",
      "Jenis dokumen dapat berubah mengikuti layanan, risiko, teknologi, dan peraturan. Hanya data yang relevan & diperlukan yang diminta.",
    ],
  },
  {
    no: "4",
    title: "Ketentuan Khusus KTP-el",
    body: [
      "Wajib KTP-el milik sendiri, jelas terbaca, tidak palsu, tidak dimanipulasi/diedit digital, dan sesuai identitas akun.",
      "Dilarang mengunggah KTP orang lain, palsu, hasil manipulasi, perolehan melawan hukum, atau untuk identitas palsu.",
      "Cariinjasa memeriksa kesesuaian data dengan dokumen. Data KTP mengandung Data Kependudukan & Data Pribadi yang diproses terbatas sesuai tujuan.",
    ],
  },
  {
    no: "5",
    title: "Ketentuan Khusus SKCK",
    body: [
      "Wajib SKCK milik sendiri yang diterbitkan Polri melalui prosedur sah (rujukan: Perpol No. 1 Tahun 2026, berlaku 20 Mei 2026).",
      "Dilarang mengunggah SKCK orang lain, memalsukan, mengubah/menyembunyikan isi material, atau memberi keterangan tidak benar.",
      "Catatan kejahatan dalam SKCK adalah Data Pribadi spesifik (UU PDP) — hanya dipakai untuk verifikasi, keamanan, manajemen risiko & kepatuhan hukum.",
    ],
  },
  {
    no: "6",
    title: "Pernyataan & Jaminan Worker",
    body: [
      "Dengan mengunggah, Worker menjamin: info benar & tidak menyesatkan; dokumen milik sendiri/sah; tidak palsu/dimanipulasi; tidak menyembunyikan info material; bertanggung jawab atas keaslian; bersedia klarifikasi/dokumen tambahan.",
      "Info/dokumen palsu berakibat penolakan/penghentian verifikasi dan tindakan sesuai hukum.",
    ],
  },
  {
    no: "7",
    title: "Dasar & Tujuan Pemrosesan Data",
    body: [
      "Dasar (UU PDP Pasal 20): persetujuan eksplisit; pemenuhan perjanjian pendaftaran; kepentingan sah Cariinjasa yang seimbang; dan/atau dasar sah lain.",
      "Tujuan: verifikasi identitas & kelayakan; pastikan akun dipakai pemilik sah; keamanan; cegah penyalahgunaan/penipuan/pemalsuan; manajemen risiko; tangani laporan/sengketa; penuhi kewajiban hukum. Tidak dipakai di luar tujuan yang diberitahukan tanpa dasar sah.",
    ],
  },
  {
    no: "8",
    title: "Persetujuan Pemrosesan Data",
    body: [
      "Persetujuan diberikan eksplisit via mekanisme elektronik (centang) yang jelas menunjukkan kehendak Anda.",
      "Anda berhak tahu: identitas pengelola, dasar hukum, tujuan, jenis data, retensi, jangka waktu pemrosesan, dan hak Anda. Bukti persetujuan disimpan Cariinjasa (UU PDP Pasal 24).",
    ],
  },
  {
    no: "9",
    title: "Pemrosesan Terbatas & Spesifik",
    body: [
      "Hanya data relevan & diperlukan untuk KYC. Prinsip: terbatas, spesifik, sah, transparan, akurat, lengkap, mutakhir, akuntabel, dan aman.",
    ],
  },
  {
    no: "10",
    title: "Akses Terhadap Dokumen",
    body: [
      "Hanya pihak berwenang dengan kebutuhan kerja sah (need-to-know, hak akses per fungsi). Customer TIDAK mendapat foto KTP, NIK penuh, SKCK, atau isi catatan kepolisian — hanya badge “Terverifikasi”.",
      "Aktivitas akses dicatat untuk keamanan, audit, dan investigasi.",
    ],
  },
  {
    no: "11",
    title: "Pihak Ketiga / Prosesor Data",
    body: [
      "Cariinjasa dapat memakai penyedia teknologi (cloud, penyimpanan, pemrosesan dokumen, verifikasi identitas, monitoring keamanan) yang hanya memproses sesuai instruksi & perjanjian pelindungan data. Cariinjasa tetap bertanggung jawab atas pemrosesan tersebut.",
    ],
  },
  {
    no: "12",
    title: "Transfer Data",
    body: [
      "Diproses di wilayah Indonesia sepanjang memungkinkan. Transfer ke luar negeri hanya sesuai ketentuan transfer UU PDP dan diinformasikan bila diwajibkan hukum.",
    ],
  },
  {
    no: "13",
    title: "Keamanan Data",
    body: [
      "Langkah keamanan sesuai risiko: batas akses, autentikasi, enkripsi, pencatatan akses, monitoring, backup/recovery, pengamanan DB & jaringan, dan pengujian keamanan.",
      "Tidak ada sistem yang 100% bebas risiko, namun Cariinjasa menerapkan upaya wajar dan mencegah akses/penggunaan/pengungkapan tanpa hak.",
    ],
  },
  {
    no: "14",
    title: "Retensi & Penghapusan",
    body: [
      "Disimpan tidak lebih lama dari yang diperlukan untuk tujuan pemrosesan, kecuali diwajibkan/diizinkan hukum. Setelah tujuan tercapai dan tak ada kewajiban/kebutuhan sah, data dihapus/dimusnahkan.",
      "Jangka waktu rinci mengikuti Kebijakan Privasi/pemberitahuan KYC yang berlaku.",
    ],
  },
  {
    no: "15",
    title: "Hak Worker & Penarikan Persetujuan",
    body: [
      "Hak (UU PDP): informasi pemrosesan, akses, koreksi, penghapusan, pembatasan, keberatan, penarikan persetujuan, dan hak lain sesuai hukum.",
      "Penarikan tidak memengaruhi keabsahan pemrosesan sebelumnya. Jika dasar sah hilang, pemrosesan dihentikan; data yang wajib disimpan untuk hukum/sengketa/pembuktian tetap dapat disimpan.",
      "Kontak pelindungan data: privacy@cariinjasa.com.",
    ],
  },
  {
    no: "16",
    title: "Dokumen Palsu, Penyalahgunaan & Insiden",
    body: [
      "Dokumen palsu/manipulasi dilarang keras. Bila diduga, Cariinjasa dapat: menolak/menunda, minta klarifikasi/dokumen tambahan, batasi/nonaktifkan akun sementara/permanen, dan menempuh langkah hukum/melapor ke berwenang.",
      "Dilarang menyalahgunakan dokumen milik orang lain. Insiden kegagalan pelindungan data ditangani via investigasi, mitigasi, dokumentasi, dan pemberitahuan sesuai kewajiban hukum.",
      "Worker wajib jaga akun/password/OTP, tidak berbagi akses, segera lapor dugaan pengambilalihan. Verifikasi ulang dapat diminta (dokumen kedaluwarsa, anomali, fraud).",
    ],
  },
  {
    no: "17",
    title: "Perubahan, Hukum & Dasar Hukum",
    body: [
      "Ketentuan dapat berubah karena layanan/teknologi/risiko/operasional/hukum; perubahan berdampak pada pemrosesan diberitahukan sesuai UU PDP. Dibaca bersama Kebijakan Privasi. Hukum yang berlaku: Republik Indonesia.",
      "Dasar hukum: UU 27/2022 (PDP); UU 23/2006 jo. 24/2013 (Adminduk); PP 71/2019 (PSTE); Perpol 1/2026 (SKCK); serta peraturan terkait lain.",
    ],
  },
];

export const SNK_CHECKBOXES = [
  {
    id: "data",
    label: "Saya menyetujui pemrosesan Data Pribadi untuk keperluan KYC dan verifikasi Worker.",
  },
  {
    id: "truth",
    label: "Saya menyatakan bahwa seluruh dokumen dan informasi yang saya berikan adalah benar dan sah.",
  },
];

export function loadSnkConsent(userId) {
  try {
    const raw = localStorage.getItem(snkConsentKey(userId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.version !== SNK_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveSnkConsent(userId) {
  const payload = {
    version: SNK_VERSION,
    acceptedAt: new Date().toISOString(),
    statement: SNK_CONSENT_STATEMENT,
  };
  try {
    localStorage.setItem(snkConsentKey(userId), JSON.stringify(payload));
  } catch {
    /* abaikan — backend tetap mencatat bukti persetujuan */
  }
  return payload;
}
